import { FlexContainer } from '@act/storybook';
import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface ReportsPageHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

/**
 * Consistent page title row for reports subdomain screens.
 * @param title - Primary heading text.
 * @param subtitle - Optional supporting line under the title.
 * @param action - Optional trailing control (e.g. primary button).
 */
const ReportsPageHeader = ({
  title,
  subtitle,
  action,
}: ReportsPageHeaderProps) => {
  return (
    <FlexContainer
      direction="row"
      alignItems="flex-start"
      justifyContent="space-between"
      width="100%"
      height="auto"
      overflowAllVisible={true}
      gap={2}
      flexWrap={true}
    >
      <FlexContainer
        direction="column"
        gap={0.5}
        height="auto"
        overflowAllVisible={true}
      >
        <Typography variant="h5" component="h1">
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        ) : null}
      </FlexContainer>
      {action ? (
        <FlexContainer
          direction="row"
          alignItems="center"
          height="auto"
          overflowAllVisible={true}
          flexShrink={0}
        >
          {action}
        </FlexContainer>
      ) : null}
    </FlexContainer>
  );
};

export default ReportsPageHeader;
